import React, { useEffect } from 'react'
import { translate } from '../../../translation'
import { useCallPipedriveApi } from '../../../utils/helpers'
import HookSelector from '_COMPONENTS/HOOK/HookSelector/HookSelector'
import { Category, PipedriveField } from 'Types'
import { useNotification } from '_CONTEXT/hook/contextHook'
import { AxiosResponse } from 'axios'
import { observer } from 'mobx-react-lite'
import { pipedriveFieldsStore } from '_STORES/PipedriveFields'
import { hookStore } from '_STORES/Hooks'
import { appDataStore } from '_STORES/AppData'
import HookFieldList from '_COMPONENTS/HOOK/HookField/HookFieldList'


const FieldCategory = ({ category }: { category: Category }) => {


  const callPipedriveApi = useCallPipedriveApi()

  const { addNotification } = useNotification()

  const categoryFields = pipedriveFieldsStore.getCategoryFields(category);

  const selectedHook = hookStore.selectedHookId
    ? hookStore.getHook(hookStore.selectedHookId)
    : null

  useEffect(() => {
    if (category !== selectedHook?.category) {
      hookStore.selectHookId(null)
    }
  }, [category, selectedHook])

  const getCategoryFields = (e: React.FormEvent) => {
    e.preventDefault()
    if (hookStore.selectedHookId) {
      callPipedriveApi(`${category}Fields`, null, null, { limit: 500 }, e)
        .then((res: AxiosResponse<any, any> | null) => {
          if (!res?.data?.data) {
            throw Error("No data in Pipedrive response")
          }
          const fields: PipedriveField[] = res.data.data.map((field: PipedriveField) => {
            return { ...field as PipedriveField, category: category }
          });

          // [DEBUG] Diagnostic champs custom manquants
          console.log(`[W2P] ${category}Fields renvoyés par Pipedrive:`, fields.length)
          console.log(`[W2P] custom fields:`, fields.filter(f => f.is_custom_field).map(f => ({ name: f.field_name, code: f.field_code, optional: f.is_optional_response_field })))
          console.log(`[W2P] écartés par isFieldValid:`, fields.filter(f => !pipedriveFieldsStore.isFieldValid(f)).map(f => ({ name: f.field_name, code: f.field_code, optional: f.is_optional_response_field })))

          const addedFieds = pipedriveFieldsStore.addPipedriveFields(fields)
          hookStore.updateHookFieldsFromPipedriveFields(addedFieds)
        })

        .catch(error => {
          addNotification({
            error: true,
            content: translate("Pipedrive has encountered an error, make sure you have configured it correctly")
          })
        })
    }
  }



  return (
    <div key={category}>
      <div>
        <div className='w2p-instructions'>
          <p>{translate(`Select the different events that will sync data from Woocommerce and WordPress informations to ${category}'s in Pipedrive.`)}</p>
        </div>

        <div className="flex flex-wrap justify-stretch gap-2 mt-5 mb-5">
          {appDataStore.appData.CONSTANTES.W2PCIFW_HOOK_LIST
            .filter(hook => !hook?.disabledFor?.includes(category))
            .map(hook => {
              return <HookSelector key={hook.key} preHook={hook} category={category} />
            })}
        </div>

        {selectedHook
          ? <HookFieldList hook={selectedHook} />
          : <h3 className='m-t-25 center'>{translate('Select an event to configure it')}</h3>
        }
      </div>

      {
        selectedHook
          ? <form onSubmit={e => getCategoryFields(e)}>
            <button className='m-t-25 light-button'>
              {categoryFields?.length
                ? translate('Reload custom fields')
                : translate('Load custom fields')}
            </button>
          </form>
          : null
      }

    </div >
  );
};

export default observer(FieldCategory);